import React from 'react';
import style from './loader.module.scss';

export const Loader = () => (
  <div className={style.loader_mask}>
    <div className={style.loader}>Loading...</div>
  </div>
);
